import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

/*
 * inherits from joint.shapes.html.QuestionBoxView
 * (which must have been declared before calling this constructor)
 */
export function MessageWithoutQRBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  function getBoxTemplate() {
    let questionAddButtonDiv = '';
    if (siteTypeConfig.hasAddUrlButtonButton) {
      questionAddButtonDiv =
        '<button class="center-block btn btn-alcmeon-default question-add-button">' +
        services.$translate.instant('parameters/quick_replies/message-without-qr-box/add_url_button') +
        '</button>';
    }

    return [
      '<div class="html-element">',
      '  <div class="question-media-content">',
      '    <img src="" width="100%">',
      '    <video preload="" controls="" src="" width="100%" style="pointer-events: auto;"></video>',
      '    <div class="question-file-attachment">',
      '      <span class="glyphicon glyphicon-file"></span>',
      '      <span class="question-file-name"></span>',
      '    </div>',
      '  </div>',
      '  <div class="question-text-content-container">',
      '    <div class="question-text-content"></div>',
      '    <div class="question-edit-container"><span class="glyphicon glyphicon-pencil question-edit"></span></div>',
      '    <div class="html-element add-item-to-parent question-add-button-container">',
      questionAddButtonDiv,
      '    </div>',
      '  </div>',
      '</div>',
    ].join('');
  }

  return joint.shapes.html.QuestionBoxView.extend({
    template: getBoxTemplate(),

    initialize: function () {
      joint.shapes.html.QuestionBoxView.prototype.initialize.apply(this, arguments);
      this.$box.find('.question-add-button-container').on('click', () => this.addButton());
    },

    addButton: function (label, answerType, editable) {
      // 4 because we always have a "next" output and only 3 buttons are allowed
      if (this.model.getEmbeddedCells().length < 4) {
        services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId).then((response) => {
          let answer = this.createButton(response.data.id);
          this.model.graph.addCell(answer);
          this.model.embed(answer);
          this.reorderChildren();
          this.resizeBox();
        }, services.AlertingFactory.httpErrorHandler());
      }
    },

    createButton: function (id, position = TMP_ELEMENT_POSITION, size = TMP_ELEMENT_SIZE, elementData = {}) {
      return new joint.shapes.html.MessageWithoutQRURLButton({ id, position, size, elementData });

      // caller is responsible for calling addCell(answer), this.reorderChildren(), this.resizeQuestionBox(),
      // and this.updateValidity(), if and when necessary
    },

    /**
     * Overrides superclass
     * The "next" element always comes last
     */
    isChildAlwaysLast: function (child) {
      return child.get('type') === 'html.Next';
    },

    paddingTop: function () {
      const $questionAddButton = this.$box.find('.question-add-button');
      return joint.shapes.html.QuestionBoxView.prototype.paddingTop.apply(this, arguments) + $questionAddButton.outerHeight();
    },

    resizeBox: function () {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('MessageWithoutQRBoxView - resizeBox()');
      }
      joint.shapes.html.QuestionBoxView.prototype.resizeQuestionBox.apply(this, arguments);
    },
  });
}
